// extracted by mini-css-extract-plugin
module.exports = {"container":"CardContact_container__bbf1s","text":"CardContact_text__9_Bhq"};